export const setLocal = (key, data) => {
    localStorage.setItem(key, data)
}

export const getLocal = (key) => {
    let get = localStorage.getItem(key);
    return get;
}